exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".component---1R9EI {\n  height: calc(100% - 90px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 0 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin-top: 6px; }\n  .component---1R9EI .certificates---20GWZ {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center; }\n  .component---1R9EI > div:first-of-type {\n    padding: 16px 0; }\n  .component---1R9EI .student-info---3fILG {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    margin: 16px 0 32px; }\n  .component---1R9EI .student-info---3fILG > div {\n      margin: 0 8px; }\n  .component---1R9EI .student-info---3fILG > div:first-of-type {\n        margin-left: 0; }\n  .component---1R9EI .student-info---3fILG > div:last-of-type {\n        margin-right: 0; }\n", ""]);

// exports
exports.locals = {
	"component": "component---1R9EI",
	"certificates": "certificates---20GWZ",
	"student-info": "student-info---3fILG"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./containers/participation/student/student.scss
// module id = KsCg
// module chunks = 1